// Keep address parsing usable in the browser without importing Node services.
module.exports = { URL };
